import styled from "styled-components";
export const SearchInput = styled.input`
  width: ${(props) => props.searchbarwidth || "100%"};
  height: ${(props) => props.searchbarheight || "100%"};
  padding: 7.5px 34px; /* Padding adjusted for the icon */
  font-size: 12px !important;
  border-radius: 6px;
  border: 1px solid var(--Stroke-Color-Stroke-100, #dddee3);
  box-shadow: 0px 1px 2px 0px #1018280d;
  background-color: #fff;
  color: #5A6C87;
  outline: none;
  transition: border 0.2s ease-in-out;
 /* Correctly targeting the placeholder */
  &::placeholder {
    color: #999; /* Placeholder text color */
    font-size: 12px !important; /* Placeholder font size */
    font-style: italic; /* Optional: make placeholder italic */
    visibility: hidden;
  }

  &:focus {
    //outline: none;
    border: 1px solid #0C53BB;
  }
`;
export const SearchWrapper = styled.div`
  position: relative;
  height: 32px;
  width: 100%;
  input ::placeholder {
    color: #999; /* Placeholder text color */
    font-size: 12px; /* Placeholder font size */
    font-style: italic; /* Optional: make placeholder italic */
  }

  &:hover ${SearchInput} {
    border: 1px solid #0C53BB;
  }
`;



export const SearchIconWrapper = styled.img`
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
`;

export const CloseIconWrapper = styled.img`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  cursor: pointer;
  opacity: ${(props) => (props.show ? 1 : 0)};
  transition: opacity 0.2s ease-in-out;
  z-index: 1;

  &:hover {
    opacity: 0.7;
  }
`;

export const PlaceholderText = styled.span`
  position: absolute;
  left: 35px;
  top: 55%;
  transform: translateY(-50%);
  font-size: 12px;
  color: #aaa;
  pointer-events: none;
`;
